<template>
    <section class="experience">
        <h3 class="mb-8">Autres savoir-faire :</h3>

        <div class="flex items-center gap-3 mb-8">
            <!-- <vs-button
                v-if="canUpdate()"
                id="addTraining"
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-plus"
                @click="createResource()"
                style="margin-bottom: 2em;"
            >
                Ajouter un savoir-faire
            </vs-button> -->
            <feather-icon 
                icon="SettingsIcon" 
                class="option cursor-pointer opaver"
                @click="showOptions = true"
            />
        </div>

        <DialogPrompt
            :active.sync="showOptions"
            title="Ordonner les savoir-faire en cours"
            cancel-text="Annuler"
            accept-text="Enregistrer"
            @cancel="showOptions = false"
            @close="showOptions = false"
            @accept="closeDialogOrderHandle()"
        >
            <Draggable 
                :data="currentOrderedItems"
                :table="{
                    columns: [
                        { label: 'Ordre', name: 'order' },
                        { label: 'Nom', name: 'occupation_skillable.title' }
                    ]
                }"
                @updated="updatedOrder = $event"
            />

        </DialogPrompt>

        <DialogPrompt
            :active.sync="showPopup"
            :title="getDataPrompt.title"
            cancel-text="Annuler"
            accept-text="Enregistrer"
            :button-accept="getDataPrompt.btnAccept"
            :is-valid="!hasError"
            @cancel="resetResource"
            @close="resetResource"
            @accept="storeResource"
        >
            <div class="con-exemple-prompt">
                                
                
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <h4 class="pt-8">
                            {{ data_get(resource, 'careereable.title') }}
                        </h4>
                    </div>
                    <div class="vx-col sm:w-1/3 w-full">
                        <vs-input
                            label="Début*"
                            type="date"
                            v-model="resource.start_at"
                            name="start_at"
                            class="w-full"
                        />
                    </div>
                    <div class="vx-col sm:w-1/3 w-full">
                        <vs-input
                            label="Fin"
                            type="date"
                            v-model="resource.end_at"
                            name="end_at"
                            class="w-full"
                        />
                    </div>
                </div>
             </div>
        </DialogPrompt>

        <vs-table
            :sst="true"
            @sort="eventSortByCol"
            :data="orderedItems"
            no-data-text="Aucune donnée à afficher"
            style="width:100%;"
        >
            <template slot="thead">
                <vs-th>
                    Libellé
                </vs-th>
                <vs-th>
                    <Sort :value="apiParams.sortBy['start_at']" name="start_at" @sort="eventSortByCol">Date de début</Sort>
                </vs-th>
                <vs-th>
                    <Sort :value="apiParams.sortBy['end_at']" name="end_at" @sort="eventSortByCol">Date de fin</Sort>
                </vs-th>
                <vs-th v-if="canUpdate()">
                    Actions
                </vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr
                    v-for="(item, i) in data"
                    :key="i"
                    :data="item"
                >
                    <vs-td :data="data_get(item, 'careereable.title')">
                        {{ data_get(item, 'careereable.title') }}
                        <template v-if="data_get(item, 'careereable.resource') == 'AdminOccupationSkill'">
                            ({{ data_get(item, 'careereable.type') }})
                        </template>
                    </vs-td>
                    <vs-td :data="data_get(item, 'start_at')">
                        {{ localFormatDate(data_get(item, 'start_at')) }}
                    </vs-td>
                    <vs-td :data="data_get(item, 'end_at')">
                        {{ data_get(item, 'end_at') ? localFormatDate(data_get(item, 'end_at')) : '-' }}
                    </vs-td>

                    <vs-td v-if="canUpdate()">
                        <vs-button
                            v-if="can('update', 'employees')"
                            :id="'modifyJob_' + i"
                            v-tooltip="'Modifier'"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-edit"
                            @click="updateResource(item)"
                        />
                        <vs-button
                            v-if="can('update', 'employees')"
                            :id="'deleteJob_' + i"
                            v-tooltip="'Supprimer'"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-trash"
                            style="margin-left: 1rem;"
                            @click="deleteResource(item)"
                        />
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
    </section>
</template>

<script>
import Multiselect from "vue-multiselect";
//import Datepicker from "vuejs-datepicker";
import { fr } from "vuejs-datepicker/dist/locale";
import { format } from 'date-fns';
import {data_get} from '@assets/utils/helpers/data_get.js';
import { formatDate as localFormatDate } from "@assets/utils/helpers/helpers.js";

export default {
    name: "EmployeeOccupations",
    components: {
        Multiselect,
        //Datepicker,
    },
    props: {
        api: {
            type: String
        },
        employee: {
            required: false,
            type: Object
        },
    },
    data() {
        return {
            data_get,
            localFormatDate,
            fr: fr,
            log: console.log,
            resource: {},
            showPopup: false,
            showOptions: false,
            loading: true,
            formError: true,
            formType: "create",
            occupationSkills: {
                data: [],
                loading: false
            },
            prompt: {
                show: {
                    title: "Consulter un savoir-faire",
                    btnAccept: "false"
                },
                create: {
                    title: "Ajouter un savoir-faire",
                    btnAccept: "filled"
                },
                update: {
                    title: "Modifier un savoir-faire",
                    btnAccept: "filled"
                }
            },
            updatedOrder: []
        };
    },
    watch: {},
    computed: {
        hasError() {
            let error = true;

            error = !this.resource.start_at

            return error;
        },
        orderedItems() {
            if (!this.items.length) return []

            return this.items.map(item => {
                item.order = item.order == 0 ? 9999 : item.order;
                return item;
            }).sort((a, b) => a.order > b.order ? 1 : -1)
        },
        currentOrderedItems() {
            return _.cloneDeep(this.orderedItems).filter(i => !i.end_at).map((item, i) => {
                item.order = i + 1
                return item
            })
        }
    },
    methods: {
        // loadOccupationSkills() {
        //     this.occupationSkills.loading = true;
        //     window
        //         .axios({
        //             method: "get",
        //             url: "/api/referentiel/occupation-skills",
        //             params: { perpage: 999, sortBy: {"title": "asc"}, include: []}
        //         })
        //         .then(response => {
        //             this.occupationSkills.data = response.data.data;
        //             this.occupationSkills.loading = false;
        //         })
        //         .catch(err => {
        //             console.log(err);
        //             this.notifyError(err, `Une erreur est survenue`);
        //         });
        // },

        canUpdate() {
            return this.canMulti("update", "employees", this.employee.services.map(s => s.id));
        },

        createResource() {
            this.resourceReadonly = false;
            this.resetResource();
            this.formType = "create";
            this.showPopup = true;
        },

        updateResource(resource) {
            this.resourceReadonly = false;
            this.resetResource();
            this.setResource(resource);
            this.formType = "update";
            this.showPopup = true;
        },

        storeResource() {
            let data = JSON.parse(JSON.stringify(this.resource));
            //data.end_date = this.resource.end_date ? this.getDate(this.resource.end_date) : this.resource.end_date;

            this.localLoading()
            if (data.id) {
                this.apiUpdate(
                    data,
                    this.resource.id,
                    resp => {
                        this.loadItems()
                        this.$emit('change')
                        this.endLocalLoading()
                    },
                    (err) => {
                        this.showPopup = true
                        this.endLocalLoading()
                    }
                );
            } else {
                this.apiCreate(
                    data,
                    resp => {
                        this.loadItems()
                        this.$emit('change')
                        this.endLocalLoading()
                    },
                    (err) => {
                        this.showPopup = true
                        this.endLocalLoading()
                    }
                );
            }
        },

        deleteResource(resource) {
            this.apiDelete(resource.id, () => {
                this.loadItems()
                this.$emit('change')
            });
        },

        setResource(data) {
            console.log('SET', data)
            let dataTemp = JSON.parse(JSON.stringify(data));
            dataTemp.start_at = dataTemp.start_at;
            dataTemp.end_at = dataTemp.end_at;
            this.resource = dataTemp;
        },

        resetResource() {
            this.resource = {
                start_at: format(new Date(), "yyyy-MM-dd"),
                end_at: null,
                doc_path: null,
            };
        },

        closeDialogOrderHandle() {
            this.showOptions = false;
            const items = this.updatedOrder.length > 0 ? this.updatedOrder : this.currentOrderedItems

            this.updatedOrderHandle(items)
        },

        updateOrderHandle(items) {
            let toUpdate = [];
            items.forEach((item, i) => {
                this.setResource(item)
                toUpdate.push(this.storeResource());
            });

            this.resetResource();

            Promise.all(toUpdate).then(() => {
                this.notifySuccess('Succès', 'Ordre modifié avec succès !')
                this.orderChanged = false;
                this.dragging = null;
                this.loadItems();
            })
        }
    },
    created() {
        this.apiParams = {
            include: ['careereable'],
            sortBy: {"end_at": "desc"}
        };
        this.resetResource();
        this.loadItems();
        //this.loadOccupationSkills();
    }
};
</script>

<style lang="scss" scoped>
::v-deep .con-text-validation {
    font-size: 0.8rem;
}
</style>
